import { mapState, mapActions } from 'vuex'

export default {
  name: 'TTableImportFiles',
  components: {
    TFileEmpty: () => import('@/components/file-empty')
  },

  data() {
    return {
      thead: [
        { label: 'Status', name: 'status' },
        { label: 'Data', name: 'import_files.created_at' },
        { label: 'Fornecedor', name: 'provider' },
        { label: 'Nome do arquivo', name: 'filename' }
      ],
      totalPages: "0",
      currentPage: 1,
      pagesSelected: "0",
      total: 0,
      limit: 50,
      disabledPrev: false,
      disabledNext: false,
      titleEmpty: 'Você ainda não tem nenhum arquivo importado',
      titleButton: 'Importe um arquivo',
      empty: false,
      hideButton: false,
      nameFileError: '',
      currentSort: 'import_files.created_at',
      currentSortDir: 'desc'
    }
  },

  props: {
    files: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState({
      loading: ({ importFile }) => importFile.loading,
      listImportFiles: ({ importFile }) => importFile.listImportFiles,
      metaDataFiles: ({ importFile }) => importFile.metaDataFiles,
      campaignId: ({ campaign }) => campaign.campaign.id,
      hasCampaign: ({ campaign }) => campaign.campaign,
      statusPending: ({ importFile }) => importFile.statusPending,
    })
  },

  methods: {
    ...mapActions('importFile', ['getAllFiles', 'getAllStatus', 'registerFile', 'getFileId']),

    actionButton () {
      this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL', true)
    },

    sort (item) {
      this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      this.currentSort = item;

      this.getAllFiles(
        {
          page: this.metaDataFiles.currentPage,
          limit: this.limit,
          campaignId: Number(this.campaignId),
          orderBy: this.currentSort,
          order: this.currentSortDir
        }
      )
    },

    statusClass (item, key) {
      if (item === 'Importado') {
        return 'color-success'
      } else if  (item === 'Importando') {
        return 'color-processing'
      } else if  (item === 'Registrado') {
        return 'color-registred'
      } else if  (item === 'Registrando') {
        return 'color-processing'
      } else if  (item === 'Falha' || item === 'Falha') {
        return 'color-error'
      }
    },

    register (id) {
      this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_REGISTER', true)
      this.$store.commit('importFile/SET_ID_FILE_REGISTER', id)
    },

    disabledPrevButton () {
      this.metaDataFiles.currentPage === 1 ? this.disabledPrev = true : this.disabledPrev = false
    },

    disabledNextButton () {
      this.metaDataFiles.currentPage === this.metaDataFiles.totalPages ? this.disabledNext = true : this.disabledNext = false
    },

    prevPage () {
      if (this.currentPage === 1) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.getAllFiles(
        {
          page: Number(this.currentPage) - 1,
          limit: this.limit,
          orderBy: this.currentSort,
          order: this.currentSortDir,
          campaignId: Number(this.campaignId)
        }
      )
    },

    nextPage () {
      if (this.currentPage === this.totalPages) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.getAllFiles(
        {
          page: Number(this.currentPage) + 1,
          limit: this.limit,
          orderBy: this.currentSort,
          order: this.currentSortDir,
          campaignId: Number(this.campaignId)
        }
      )
    },

    goToPage (page) {
      if (Number(page) < 0 || Number(page) > Number(this.totalPages)) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.currentPage = page
      this.getAllFiles(
        {
          page: Number(page),
          limit: this.limit,
          orderBy: this.currentSort,
          order: this.currentSortDir,
          campaignId: Number(this.campaignId)
        }
      )
    },

    updateMetaDataTable () {
      if ( this.metaDataFiles ) {
        this.totalPages = `${this.metaDataFiles.totalPages}`
        this.currentPage = `${this.metaDataFiles.currentPage}`
        this.pagesSelected = `${this.metaDataFiles.limitValue}`
        this.total = this.metaDataFiles.totalCount
      }
    },

    getStatus () {

        const statusImporting = this.listImportFiles.filter(item => item.s === 'importing')

        if (statusImporting.length !== 0) {
          const idFile = statusImporting[0].id
          setTimeout(() => {
            this.getFileId({id: Number(idFile)})
          }, 2000)
          this.nameFileError = statusImporting[0].provider
        }


        const statusRegistering = this.listImportFiles.filter(item => item.s === 'registering')
        if (statusRegistering.length !== 0) {
          const idFile = statusRegistering[0].id
          setTimeout(() => {
            this.getFileId({id: Number(idFile)})
          }, 2000)
          this.nameFileError = statusRegistering[0].provider
        }


    }
  },

  watch: {
    loading (value) {
      if (value === false) {
        if (this.listImportFiles.length === 0) {
          this.empty = true
          this.hideButton = true
        } else {
          this.empty = false
        }
      }
    },

    statusPending (status) {
      if (status) {
        this.getAllFiles({page: Number(this.currentPage), limit: Number(this.limit), campaignId: this.campaignId, orderBy: this.currentSort, order: this.currentSortDir})
        this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'error')
        this.$store.commit('statusBar/SET_TITLE_BAR', `Falha ao importar arquivo <i>${this.nameFileError}</i>.`)
        setTimeout( () => {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
        }, 9000)
        this.$store.commit('TOGGLE_STATUS', false)
      }
    }
  },

  mounted () {
    if (this.hasCampaign)  {
      this.getAllFiles({page: Number(this.currentPage), limit: Number(this.limit), campaignId: this.campaignId, orderBy: this.currentSort, order: this.currentSortDir})
      this.getStatus({page: Number(this.currentPage), limit: Number(this.limit), campaignId: this.campaignId, orderBy: this.currentSort, order: this.currentSortDir})
      this.updateMetaDataTable()
    } else {
      this.empty = true
    }
  },

  updated () {
    this.getStatus({page: Number(this.currentPage), limit: Number(this.limit), campaignId: this.campaignId, orderBy: this.currentSort, order: this.currentSortDir})
  }
}
